<script lang="ts" setup>
import { markdown } from '@/utils/markdown'

defineProps<{
    title: string
    /** Supports markdown-it inline syntax: **bold**, *italic*, \n → <br> */
    description?: string
    size?: 'small' | 'medium'
}>()
</script>
<template>
    <header>
        <h2 :class="size === 'small' ? 'text-base leading-6' : 'text-xl'" class="inline mr-1">
            {{ title }}
        </h2>
        <!-- v-html is required to render user-provided descriptions with inline markdown formatting (bold, italic, line breaks); markdown.renderInline runs DOMPurify.sanitize to mitigate XSS. -->
        <!-- eslint-disable vue/no-v-html -->
        <p
            v-if="description"
            :class="size === 'small' ? 'text-base leading-6' : 'text-xl'"
            class="inline text-neutral-600"
            v-html="markdown.renderInline(description)"
        ></p>
        <!-- eslint-enable vue/no-v-html -->
    </header>
</template>
